import React, { PropsWithChildren } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';

interface DialogItemProps {
  open: boolean;
  title?: string;
  text?: string;
  isErrorMessage?: boolean;
  handleClose: () => void;
  noDefaultActionsRow?: boolean;
  closeIcon?: boolean;
  fullScreen?: boolean;
  headerIcon?: React.ReactElement;
}

const DialogItem = (props: PropsWithChildren<DialogItemProps>) => {
  const {
    open,
    title,
    text,
    isErrorMessage,
    children,
    handleClose,
    noDefaultActionsRow,
    closeIcon,
    fullScreen,
    headerIcon,
  } = props;

  const errorClass = isErrorMessage ? 'error-message' : 'operation-message';

  return (
    <Dialog open={open} onClose={handleClose} className={errorClass} fullScreen={fullScreen}>
      {closeIcon && (
        <IconButton
          id='dialogItemCloseIconBtn'
          onClick={handleClose}
          style={{
            right: 5,
            top: 5,
          }}
          sx={{ position: 'absolute' }}
        >
          <CloseIcon id='dialogItemCloseIconBtnCloseIcon' />
        </IconButton>
      )}
      {title && (
        <DialogTitle>
          <>
            {headerIcon ? headerIcon : null}
            {title}
          </>
        </DialogTitle>
      )}
      <DialogContent>
        {text ? <DialogContentText>{text}</DialogContentText> : null}
        {children}
      </DialogContent>
      {!noDefaultActionsRow && !closeIcon && (
        <DialogActions>
          <Button
            id='dialogItemCloseBtn'
            variant='contained'
            className='btn-action-basic btn-default'
            onClick={handleClose}
          >
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogItem;
